'use strict';
(function(angular) {
  angular.module('fetchtv.services')
    .factory('fetchService', [
      '$http',
      '$q',
      '$window',
      'proxyprefix',
      function(
        $http,
        $q,
        $window,
        proxyprefix,
      ) {
        function userExists(
          email,
          captchaToken,
        ) {
          var userExistsUrl =	proxyprefix + '/userExists?'
							+ 'email=' + $window.encodeURIComponent(email)
							+ '&captcha_token=' + $window.encodeURIComponent(captchaToken);
          return $http.get(userExistsUrl)
            .then(function(result) {
              return result.data.found;
            });
        }
        const startTime = new Date().toISOString(),
          endTime = new Date(Date.now() + (30 * 24 * 60 * 60 * 1000)).toISOString();

        var fallbackOutageMessages = {
          "activate": {
            "title": `Unscheduled Outage`,
            "message": `Due to a system outage, Fetch signup is currently unavailable. Please check back with us later. We apologise for any inconvenience caused.`,
            "severity": "danger",
            "blocker": 'true',
            "start_time": startTime,
            "end_time": endTime,
          },
          "tool-box": {
            "title": `Unscheduled Outage`,
            "message": `The Account portal is currently unavailable. Engineers are working on the issue as their highest priority. In the meantime, you can contact the Support Team by emailing contactus@fetchtv.com.au. Apologies for any inconvenience caused.`,
            "severity": "danger",
            "blocker": 'true',
            "start_time": startTime,
            "end_time": endTime,
          }
        };

        function getFetchTVNotification(appName, admin) {
          var url = proxyprefix + '/notifications?app_name=' + appName;

          if (admin) {
            url += '&admin=True';
          }

          return $http
            .get(url)
            .then(function(response) {
              var data = response.data;
              if (data.__meta__.error) {
                return $q.reject(data.__meta__.error);
              } else {
                return $q.resolve(data.notification);
              }
            },
              function(error) {
                // Return generic fallback.
                return fallbackOutageMessages[appName];
              },
            );
        }

        function setFetchTVNotification(data) {
        /*
         *{"activate":
         *{ "title":"Server Status",
         *"message": "Lorem ipsum dolor sit amet, consectetur adipiscing elit.",
         *"blocker": "false",
         *"end_time": "2016-07-26T22:36:00.000Z",`1
         *"start_time": "2016-07-18T22:36:00.000Z",
         *"severity": "danger"},
         *"tool-box":
         *{ "title":"Information",
         *"message": "Donec dictum, neque id tempus imperdiet, lacus felis dignissim erat.",
         *"blocker": "true",
         *"end_time": "2016-07-26T22:36:00.000Z",
         *"start_time": "2016-07-18T22:36:00.000Z",
         *"severity": "info"}
         *}
         */

          var deferred = $q.defer();
          $http
            .post(proxyprefix + '/notifications', data)
            .success(function(data) {
              if (data.__meta__.error) {
                deferred.reject(data.__meta__.error);
              } else {
                delete data.__meta__;
                deferred.resolve(data);
              }
            })
            .error(function(error) {
              deferred.reject(error);
            });
          return deferred.promise;
        }

        return {
          userExists: userExists,
          getFetchTVNotification: getFetchTVNotification,
          setFetchTVNotification: setFetchTVNotification
        };
      }]);
})(angular);
